import { ALTERAR_REGISTROS_POR_PAGINA_ROTA, DETERMINAR_PAGINA_ATUAL_ROTA } from '../../actions/types'

export const paginaAtualRota = (state = 1, action) => {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_ROTA: {
      return action.payload
    }

    default:
      return state
  }
};


export const registrosPorPaginaRota = (state = 10, action) => {
  switch (action.type) {
    case ALTERAR_REGISTROS_POR_PAGINA_ROTA: {
      return action.payload
    }

    default:
      return state
  }
};

